// extracted by mini-css-extract-plugin
export default {"recommendation-indicator":"components-hotel-channel-pricing-legend-module__recommendation-indicator","divider":"components-hotel-channel-pricing-legend-module__divider"};